"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Filter = function Filter(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3575 18.5H3.58333C2.98502 18.5 2.5 18.015 2.5 17.4167C2.5 16.8183 2.98502 16.3333 3.58333 16.3333H9.3575C9.95581 16.3333 10.4408 16.8183 10.4408 17.4167C10.4408 18.015 9.95581 18.5 9.3575 18.5ZM15.1425 13.0833H3.58333C2.98502 13.0833 2.5 12.5983 2.5 12C2.5 11.4017 2.98502 10.9167 3.58333 10.9167H15.1425C15.7408 10.9167 16.2258 11.4017 16.2258 12C16.2258 12.5983 15.7408 13.0833 15.1425 13.0833ZM20.9167 7.66667H3.58333C2.98502 7.66667 2.5 7.18164 2.5 6.58333C2.5 5.98502 2.98502 5.5 3.58333 5.5H20.9167C21.515 5.5 22 5.98502 22 6.58333C22 7.18164 21.515 7.66667 20.9167 7.66667Z"
  }));
};

exports.Filter = Filter;